import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import classNames from "classnames";

const PaginationContainer = React.memo(({ className, ...props }) => (
  <div
    {...props}
    className={classNames(styles.paginationContainer, className)}
    data-testid="pagination-container"
  />
));

PaginationContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default PaginationContainer;
